import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {TranslateModule} from '../../translate-module';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import {CompanyService} from '../../services/company.service';
import { AppDataService } from '../../services';
import { PainelAlunoComponent } from './painel-aluno.component';

@NgModule({
  declarations: [
    PainelAlunoComponent


  ],
  imports: [
    BrowserModule,
    HttpModule,
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,

    BrowserModule.withServerTransition({
      appId: 'angular-universal-firebase'
    }),


  ],
  providers: [
    CompanyService,
    AppDataService


  ],
  exports: [
    PainelAlunoComponent
    ]
})
export class PainelAlunoModule { }



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/painel-aluno/painel-aluno.module.ts